import { FunctionComponent } from "react";

import { Stack, Text, useTheme } from "@bps/fluent-ui";
import { ServerMigrationTenant } from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { ServerMigrationGuid } from "./ServerMigrationGuid";

interface ServerMigrationTenantSummaryProps {
  tenant?: ServerMigrationTenant;
  outcome: string;
}

export const ServerMigrationTenantSummary: FunctionComponent<ServerMigrationTenantSummaryProps> = ({
  tenant,
  outcome
}) => {
  const theme = useTheme();

  if (!tenant) return <Text>None</Text>;

  return (
    <Stack>
      <Stack
        horizontal
        wrap
        verticalAlign="center"
        tokens={{ childrenGap: theme.spacing.s1 }}
      >
        <Text>
          <strong>{tenant.name}</strong>
          {tenant.isInactive ? " (Inactive)" : ""}
        </Text>
        <ServerMigrationGuid value={tenant.id} />
      </Stack>
      <Text
        variant="small"
        styles={{ root: { color: theme.palette.neutralSecondary } }}
      >
        {outcome}
      </Text>
    </Stack>
  );
};
